<template>
<div id="avtoservices">
    <link href="/static/css/avtoservis/style.css" rel="stylesheet"/>
    <div class="container-fluid hesers top-block">
        <div class="container">
            <div class="row widgets">
                <div class="col-md-30">
                    <div class="widget">
                        <div class="icon">
                            <img src="/static/img/avtoservis/index/like.png">
                        </div>
                        <div class="text">
                            <span>Вчера </span>
                            <span>отремонтировано</span>
                        </div>
                        <div class="number">
                            {{yesterday_car}}
                        </div>
                    </div>
                </div>
                <div class="col-md-30">
                    <div class="widget">
                        <div class="icon">
                            <img src="/static/img/avtoservis/index/recording.png">
                        </div>
                        <div class="text">
                            <span>Сегодня</span>
                            <span>записано</span>
                        </div>
                        <div class="number">
                            {{today_car}}
                        </div>
                    </div>
                </div>
                <div class="col-md-30">
                    <div class="widget">
                        <div class="icon">
                            <img src="/static/img/avtoservis/index/tool.png">
                        </div>
                        <div class="text">
                            <span>Сейчас</span>
                            <span>в сервисе</span>
                        </div>
                        <div class="number">
                            {{s_car}}
                        </div>
                    </div>
                </div>
                <div class="col-md-30">
                    <div class="widget">
                        <div class="icon">
                            <img src="/static/img/avtoservis/index/form.png">
                        </div>
                        <div class="text">
                            <span>Сейчас заполняют</span>
                            <span>форму записи</span>
                        </div>
                        <div class="number">
                            {{s_carform}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid avtoservices-block">
        <h3 style="color: #4a80c6;"><center><br/>Если Автосервиса нет на нашем сайте, возможно, о нем плохие отзывы. <br/>Мы сотрудничаем только с проверенными СТО.</center></h3>
    </div>
    <div class="container-fluid recent-applications">
        <h2>Последние заявки</h2>
        <div class="wrapper clearfix">
            <div class="row applications">
                <div :key="order.id" class="col-md-40" v-for="order in orders">
                    <div class="application">
                        <div>
                            <span class="car">{{order.mark}}</span>
                        </div>
                        <div class="operation">
                            {{order.text}}
                        </div>
                        <div class="status-service">
                            <img src="/static/img/avtoservis/index/clock.png" v-if="order.status">
                            <span v-if="order.status">Сервис с лучшей ценой найден за {{order.time}} мин.</span>
                            <img v-if="!order.status" src="/static/img/avtoservis/index/clock-disable.png">
                            <span v-if="!order.status">Сервис подбирается уже {{order.time}} мин.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>
    <div class="container-fluid avtoservices-block">
        <div class="wrapper">
            <h2>Топ 10 автосервисов</h2>
            <p>Рейтинг основан на отзывах клиентов, которые воспользовались услугами автосервиса.</p>
            <p>Мы не сотрудничаем с автосервисами, которые имеют оценку ниже 3.5!</p>
            <div class="top-avtoservices col-md-120">
                <div class="avtoservis col-md-58 col-md-offset-2" :key="avtoservis.id"  v-for="avtoservis in avtoservices10">
                    <div class="avtoservis-top">
                        <div class="name"><router-link :to="'/avtoservis/' +avtoservis.id">{{avtoservis.name}}</router-link></div>
                        <div class="info">
                            <span class="address">({{avtoservis.property.address}})</span>
                                <i v-if="avtoservis.property.parking === '1'" class="fas fa-parking col-sm-10"></i>
                                <i v-if="avtoservis.property.tv === '1'" class="fas fa-tv col-sm-10"></i>
                                <i v-if="avtoservis.property.coffe === '1'" class="fas fa-coffee col-sm-10"></i>
                                <i v-if="avtoservis.property.wifi === '1'" class="fas fa-wifi col-sm-10"></i>
                                <i v-if="avtoservis.property.card === '1'" class="fas fa-credit-card col-sm-10"></i>
                                <i v-if="avtoservis.property.bonusin === '1' || avtoservis.property.bonus === '1'" class="fas fa-gift col-sm-10"></i>
                            <div class="right-block">
                                <div class="rating">
                                    <div class="star">
                                        <div :style="{width: avtoservis.property.rating+'%'}"></div>
                                    </div>
                                </div>
                                <div class="reviews"><span class="icon"></span><span class="reviews-count">Отзывы: {{avtoservis.property.rating_count}}</span></div>
                            </div>

                        </div>
                    </div>
                    <div class="avtoservis-content">
                        <div class="avtoservis-img">
                            <img class="card-img" :src="avtoservis.property.ava" style="width: 100%;max-height: 130px;top: 25%;position: absolute;transform: translate(0%,-25%);">
                            <router-link tag="button"  :to="'/avtoservis/' +avtoservis.id" class="button select_serv button_va_posts" :data-id="avtoservis.id">ЗАПИСАТЬСЯ</router-link>
                        </div>

                        <div class="avtoservis-comments" v-html="avtoservis.description">
                        </div>
                    </div>

                </div>
            </div>
            <button class="button btn-show-all" style="display: none">ПОКАЗАТЬ ВСЕ 10</button>
        </div>
    </div>
    <div class="container-fluid all-avtoservices-block avtoservices-block">
        <div class="wrapper">
            <h2>Все автосервисы</h2>
            <div class="map hreg" id="map-canvas" style="display: none"></div>
            <div class="all-avtoservices col-md-120">
                <div class="avtoservis col-md-58 col-md-offset-2" :key="avtoservis.id" v-for="avtoservis in avtoservices">
                    <div class="avtoservis-top">
                        <div class="name"><router-link :to="'/avtoservis/' +avtoservis.id">{{avtoservis.name}}</router-link></div>
                        <div class="info">
                            <span class="address">({{avtoservis.property.address}})</span>
                            <i v-if="avtoservis.property.parking === '1'" class="fas fa-parking col-sm-10"></i>
                            <i v-if="avtoservis.property.tv === '1'" class="fas fa-tv col-sm-10"></i>
                            <i v-if="avtoservis.property.coffe === '1'" class="fas fa-coffee col-sm-10"></i>
                            <i v-if="avtoservis.property.wifi === '1'" class="fas fa-wifi col-sm-10"></i>
                            <i v-if="avtoservis.property.card === '1'" class="fas fa-credit-card col-sm-10"></i>
                            <i v-if="avtoservis.property.bonusin === '1' || avtoservis.property.bonus === '1'" class="fas fa-gift col-sm-10"></i>
                            <div class="right-block">
                                <div class="rating">
                                    <div class="star">
                                        <div :style="{width: avtoservis.property.rating+'%'}"></div>
                                    </div>
                                </div>
                                <div class="reviews"><span class="icon"></span><span class="reviews-count">Отзывы: {{avtoservis.property.rating_count}}</span></div>
                            </div>

                        </div>
                    </div>
                    <div class="avtoservis-content">
                        <div class="avtoservis-img">
                            <img class="card-img" :src="avtoservis.property.ava" style="width: 100%;max-height: 130px;top: 25%;position: absolute;transform: translate(0%,-25%);">
                            <button class="button select_serv button_va_posts" :data-id="avtoservis.id">ЗАПИСАТЬСЯ</button>
                        </div>

                        <div class="avtoservis-comments" v-html="avtoservis.description">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
export default {
  name: 'Avtoservices',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      yesterday_car: 0,
      today_car: 0,
      s_car: 0,
      s_carform: 0,
      orders: [],
      avtoservices10: [],
      avtoservices: []
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-get-stat?city=' + this.city.id).then(response => {
      this.yesterday_car = response.data.yesterday_car
      this.today_car = response.data.today_car
      this.s_car = response.data.s_car
      this.s_carform = response.data.s_carform
      this.orders = response.data.orders
    })
    axios.get('https://crm.v-avtoservice.com/list/site-get-services?city=' + this.city.id).then(response => {
      this.avtoservices10 = response.data.avtoservices10
      this.avtoservices = response.data.avtoservices
      $('.select_serv').on('click', function () {
        $('.addfield11').show()
        $('#order-form-service').val($(this).data('id')).trigger('change')
        $('html,body').animate({scrollTop: $('#want-price').offset().top}, 500)
      })
    })
  }
}
</script>

<style scoped>
    .ml10 {
        margin-left: 10px;
    }
    .padlr0 {
        padding-left: 0px;
        padding-right: 0px;
    }

    .hreg {
        height: 600px;
    }

    .map {
        width: 100%;
        margin: 35px auto;
        background: #999;
    }

    .scroll {
        overflow-y: scroll;
    }

    .olaha {

    }

    .name {
        color: #000;
    }

    .gm-style-iw > div > div {
        overflow: hidden !important;
    }

    .gm-style-iw > div {
        overflow: hidden !important;
        width: 500px;
        margin-left: 5px;
        /*height: 120px;*/
    }

    .gm-style-iw img {
        width: 100%;
        /*margin-left: 10px;*/
        height: 120px;
    }

    .ml-25 {
        margin-left: -25px;
    }

    .gm-style-iw h3 {
        padding: 10px 10px 10px 0;
        margin: 0 0 0 10px;
        text-decoration: none;
    }

    .gm-style-iw p {
        padding: 0;
        margin: 10px 0 0 10px;
    }

    .page-numbers {
        padding-top: 11px;
        list-style: none;
        display: -moz-inline-stack;
        display: inline-block;
        vertical-align: middle;
        zoom: 1;
        width: 46px;
        height: 46px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        -ms-border-radius: 5px;
        -o-border-radius: 5px;
        border-radius: 5px;
        border: 1px solid rgba(67, 72, 76, .16);
        margin: 8px 8px 8px 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        color: #212121;
        text-decoration: none;
    }

    a.page-numbers:not(.disabled):hover {
        border-color: #f95c3c;
        text-decoration: none;
    }

    span.page-numbers.current {
        padding-top: 0;
        border: 2px solid rgba(249, 92, 60, .5);
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        -ms-border-radius: 4px;
        -o-border-radius: 4px;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 40px;
    }

    .mtitle {
        font-size: 23px;
        font-weight: 600;
        color: black;
    }

    .m-text {
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Avtoservices.vue